exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Widgets-7999bd1f .topoInner-799094ac{padding:60px 30px;margin:0 0 30px 0;font-weight:bold}.Widgets-7999bd1f .demoBox-70247842{background:#f5f5f5;padding:20px;margin:0 0 30px 0}\n", ""]);

// Exports
exports.locals = {
	"Widgets": "Widgets-7999bd1f",
	"topoInner": "topoInner-799094ac",
	"demoBox": "demoBox-70247842"
};